type Translate = (key: string, fallback?: string) => string;

/**
 * Human label for an import-diff path — shared by the full diff table and
 * the wizard's compact last-applied recap.
 */
export const diffFieldLabel = (t: Translate, path: string): string => {
  if (path.startsWith('ebook.')) {
    const field = path.replace('ebook.', '');
    return t(`user_catalog.publications.ebook.fields.${field}`, field);
  }
  if (path.startsWith('audio.')) {
    const field = path.replace('audio.', '');
    return t(`user_catalog.publications.audio.fields.${field}`, field);
  }
  if (path === 'cover_url') {
    return t('user_catalog.publications.fields.cover', 'Cover');
  }
  if (path === 'authors') {
    return t('user_catalog.publications.authors.title', 'Authors');
  }
  if (path === 'lectors') {
    return t('user_catalog.publications.lectors.title', 'Lectors');
  }
  return t(`user_catalog.publications.fields.${path}`, path);
};
